import * as React from "react";
import styled, { css } from "styled-components";
import { TextOverflowEllipsis } from "components/common";
const CardContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.global.contentBackground};
  border-radius: ${({ theme }) => theme.spacings.xs};
  padding: 7px 9px 6px;

  ${({ $clickable, theme }) => $clickable && css`
      cursor: pointer;

      &:hover {
        outline: 1px solid ${theme.colors.link.hover};
      }
    `}
`;
const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacings.xs};
  margin-bottom: 5px;
  min-height: 25px;
`;
const Headline = styled.span(
  ({ theme }) => css`
    font-size: ${theme.fonts.size.large};
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    flex: 1;
    min-width: 0;
  `
);
const ActionsWrapper = styled.span`
  display: inline-flex;
`;
const WidgetMeta = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
const TimeRangeInfo = styled(TextOverflowEllipsis)(
  ({ theme }) => css`
    color: ${theme.colors.text.secondary};
    align-self: flex-end;
    font-size: ${theme.fonts.size.small};
  `
);
const WidgetCard = ({
  headline,
  timeRangeInfo = void 0,
  timeRangeTooltip = void 0,
  actions = void 0,
  onClick = void 0,
  className = void 0,
  children = void 0
}) => /* @__PURE__ */ React.createElement(CardContainer, { $clickable: !!onClick, onClick, className }, /* @__PURE__ */ React.createElement(HeaderRow, null, /* @__PURE__ */ React.createElement(Headline, { title: headline }, headline), actions && /* @__PURE__ */ React.createElement(ActionsWrapper, { onClick: (e) => e.stopPropagation() }, actions)), children, timeRangeInfo && /* @__PURE__ */ React.createElement(WidgetMeta, null, /* @__PURE__ */ React.createElement(TimeRangeInfo, { titleOverride: timeRangeTooltip }, timeRangeInfo)));
export default WidgetCard;
